interface ProgressRailProps {
  total: number;
  done: number;
}

/**
 * ProgressRail — a hairline rule that fills with ink as a session
 * advances. The rule is `--color-rule`; the completed portion is solid
 * ink. Proportion is expressed as width, clamped to [0, 1] so a `done`
 * beyond `total` (or a zero `total`) never overflows.
 */
export function ProgressRail({ total, done }: ProgressRailProps) {
  const ratio = total > 0 ? Math.min(Math.max(done / total, 0), 1) : 0;
  const pct = `${(ratio * 100).toFixed(2)}%`;

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={Math.min(Math.max(done, 0), total)}
      className="h-px w-full bg-rule"
    >
      <div className="h-full bg-ink" style={{ width: pct }} />
    </div>
  );
}
